/* istanbul ignore file */
// eslint-disable-next-line nebula-rules/check-exist-test-file
export async function convertToBlob(
  canvas: HTMLCanvasElement,
  type = 'image/png',
): Promise<Blob | null> {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      resolve(blob);
    }, type);
  });
}
